import { Backdrop } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Blocks } from "react-loader-spinner";

// Several pages render their own local <Loader/> alongside the new global
// one, so more than one instance can be mounted at the same time. Each
// instance is the same full-screen Backdrop, so mounting two at once used to
// stack two overlays (darker screen) and two spinners. This registry ensures
// only the earliest-mounted instance ever renders the overlay; any others
// mounted concurrently render nothing.
let nextId = 0;
let mountedIds = [];
const listeners = new Set();

function notifyAll() {
  listeners.forEach((listener) => listener());
}

const Loader = () => {
  const idRef = useRef(null);
  if (idRef.current === null) {
    idRef.current = ++nextId;
  }
  const [, forceRender] = useState(0);

  useEffect(() => {
    const listener = () => forceRender((n) => n + 1);
    listeners.add(listener);
    mountedIds.push(idRef.current);
    notifyAll();

    return () => {
      mountedIds = mountedIds.filter((id) => id !== idRef.current);
      listeners.delete(listener);
      notifyAll();
    };
  }, []);

  if (mountedIds[0] !== idRef.current) {
    return null;
  }

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: 1060 }}
        open={true}
      >
        <Blocks
          visible={true}
          height="80"
          width="80"
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperClass="blocks-wrapper"
          color="#00b6ce"
        />
      </Backdrop>
    </div>
  );
};

export default Loader;
